import { FixedSchedule } from './FixedSchedule';
// eslint-disable-next-line no-duplicate-imports
import type { WorkScheduleProps } from './FixedSchedule';
import { RotationalSchedule } from './RotationalSchedule';
import { ReducedScheduleHours } from './ReducedScheduleHours';

export { DAY_SHORT, DAY_FULL, toTimeStr } from './helpers';
export type { WorkWeekValue } from './helpers';
export type { WorkScheduleProps } from './FixedSchedule';

const WeeklySchedule = ({
  onChange,
  value,
  variant = 'fixed',
  onBlur,
  processedProps,
}: WorkScheduleProps) => {
  if (variant === 'rotational') {
    return (
      <RotationalSchedule
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        processedProps={processedProps}
      />
    );
  }
  if (variant === 'reduced') {
    return (
      <ReducedScheduleHours
        onChange={onChange}
        value={value}
        onBlur={onBlur}
        processedProps={processedProps}
      />
    );
  }
  return (
    <FixedSchedule
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      processedProps={processedProps}
    />
  );
};

export default WeeklySchedule;
